import axios from 'axios';
import { env, storage_keys } from '@/constant/configs';
import Cookies from 'js-cookie';
import { i18n } from '@/i18n-config';
import { redirect } from 'next/navigation';
import { storeFront } from '@/lib/utils/routeLinks';
import { removeRestaurantAuthCreds } from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';

// const tokenData = Cookies.get(storage_keys.restaurant_token);

const instance = axios.create({
  baseURL: env.api_url + '/v1/restaurant',
});

const isServer = typeof window === 'undefined';

instance.interceptors.request.use(async (config) => {
  if (isServer) {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();

    const token = cookieStore.get(storage_keys.restaurant_token)?.value;

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  } else {
    const clientLang =
      Cookies.get(storage_keys.restaurant_lang) ?? i18n.defaultLanguage;
    config.headers['Accept-Language'] = `${clientLang}`;

    const impId = localStorage.getItem(storage_keys.res_impersonate_id);
    if (impId) {
      config.headers['x-proxy-user-id'] = impId;
    }

    //Set timezone header
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['User-Timezone'] = timezone;

    const tokenData = localStorage.getItem(storage_keys.restaurant_token);
    if (tokenData) {
      config.headers['Authorization'] = `Bearer ${tokenData}`;
    }
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem(
          storage_keys.restaurant_refresh_token
        );
        const response = await axios.post(
          env.api_url + '/v1/restaurant/issue-new-auth-token-set',
          null,
          { headers: { Authorization: `Bearer ${refreshToken}` } }
        );

        localStorage.setItem(
          storage_keys.restaurant_token,
          response.data.token
        );
        localStorage.setItem(
          storage_keys.restaurant_refresh_token,
          response.data.refresh_token
        );

        if (!isServer) {
          Cookies.set(storage_keys.restaurant_token, response.data.token, {
            expires: 90,
          });
        }

        // Retry the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${response.data.token}`;
        return axios(originalRequest);
      } catch (error2) {
        // Delete FCM token on auth failure
        if (!isServer) {
          await deleteFCMToken();
        }
        // If error on refresh token
        if (isServer) {
          // TODO: needs testing
          redirect(storeFront.loginBusiness.de());
        } else {
          removeRestaurantAuthCreds();
          window.location.href = storeFront.loginBusiness.de();
        }
      }
    }
    return Promise.reject(error);
  }
);
export default instance;
